import { render, staticRenderFns } from "./card-recently-bought.vue?vue&type=template&id=6dcc0671&scoped=true"
import script from "./card-recently-bought.vue?vue&type=script&lang=js"
export * from "./card-recently-bought.vue?vue&type=script&lang=js"
import style0 from "./card-recently-bought.vue?vue&type=style&index=0&id=6dcc0671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcc0671",
  null
  
)

export default component.exports